export default function Center({ children }: React.PropsWithChildren<{}>) {
  return <div className="flex justify-center">{children}</div>
}
